<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Notícias" pageTitle="Notícias" />
            <NewsContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import PageTitle from '../Common/PageTitle';
import NewsContent from '../News/NewsContent';
import FooterArea from '../Layouts/FooterArea';

export default {
    name: 'NewsPage',
    components: { MainHeader, PageTitle, NewsContent, FooterArea },
    mounted() { document.body.classList.add('body-bg-f8faff'); },
};
</script>
